import TreeSelect from '@/components/tree-select'
import { GetEnterpriList } from '@/api/common'
// 全局使用同一data
let data = {
  treeSelect: {
    width: 300,
    text: '',
    visible: false,
    checked: [],
    data: [],
    props: {
      value: 'EID',
      label: 'Enterprise1',
      children: 'child',
      disabled: 'disabled',
      isLeaf: 'isLeaf'
    }
  }
}

let treeSelect = {
  data() {
    return data
  },
  methods: {
    treeSelectCheck(rows) {
      this.treeSelect.checked = rows
      this.treeSelect.text = rows.map(k => k.Enterprise1).join(',')
    }
  },
  components: {
    TreeSelect
  },
  mounted() {
  },
  created() {
    GetEnterpriList(-1).then(ret => {
      data.treeSelect.data = ret.data.slice()
    }).catch(err => {
    })
  }
}

export default treeSelect



// WEBPACK FOOTER //
// ./src/views/mixins/tree-select.js